import React from 'react'
import {withStyles} from '@mui/styles'

import { TextField } from '@mui/material';
import {ruleValidation} from './customFunctions.jsx';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';

const CssTextField = withStyles({
    root: {
      
      '& label.Mui-focused': {

        //color: 'green',
      },
      '& .MuiInput-underline:after': {
        //borderBottomColor: 'green',
      },
      '& .MuiOutlinedInput-root': {
        //padding:'4px 0px',
       // borderRadius:12,
        '& fieldset': {
          borderColor: '#4F4F4F',
          //borderColor: 'red',
        },
        '&:hover fieldset': {
          //borderColor: 'yellow',
        },
        '&.Mui-focused fieldset': {
          //borderColor: 'green',
        },
      },
    },
  })(TextField);

const InputDateForm = props => {    

    const {onChange, data, disabled} = props
    const {value, isVisited, isValid} = props.data
    const {label,placeholder, helperText} = props.data.config


    const handleDateChange = (date) => {
      //console.log('Cambio')
      //console.log(date)
      //console.log(date.format('YYYY-MM-DD'))
        const response =date.format('YYYY-MM-DD');
        let temp = {...data};
        temp.value = response;
        temp.isValid = ruleValidation(temp.value, temp.rules, temp.value2);
        temp.isVisited = true;
        onChange(temp);
    }

    const error = isVisited && !isValid;

    return(
      <MobileDatePicker
        label={label}
        disabled={disabled}
        value={value}
        placeholder={placeholder}
        onChange={handleDateChange}
        renderInput={(params) => 
          <CssTextField {...params} 
            error={error} 
            helperText={error ? helperText : null}
            fullWidth
          />
        }
      />
          
    )
}

export default InputDateForm